import { jsxs as r, jsx as o } from "react/jsx-runtime";
import { useTranslation as f, useNextgenRouter as h, GenericLink as s, NextgenImage as u, LoaderType as _ } from "@nextgen-web-framework/all";
import '../../assets/LegalLink.css';const z = "#ffffff", V = "#396e75", C = "#e5fdff", p = "#546223", b = "#f0fae5", N = "#a65523", y = "#fff1e8", B = "#7f3e3e", w = "#ffe2e2", v = "#62625a", x = "#f8f8e7", G = "#38539a", O = "#707070", R = "#c8f8d1", T = "#87c9c8", W = "#5291b1", Y = "rgba(82, 145, 177, 0.1019607843)", A = "#445685", P = "#181d61", S = "rgba(24, 29, 97, 0.1019607843)", j = "#5969d6", K = "#ea999d", $ = "#b6577e", D = "rgba(182, 87, 126, 0.1019607843)", E = "#7e3e80", H = "#1e247f", q = "rgba(30, 36, 127, 0.1019607843)", F = "#da7600", J = "#107f47", M = "#d91734", Q = "_html_14r1r_38", U = "_copyright_14r1r_90", a = {
  amwayWhite: z,
  darkBlue: V,
  lightBlue: C,
  darkGreen: p,
  lightGreen: b,
  darkOrange: N,
  lightOrange: y,
  darkRed: B,
  lightRed: w,
  darkYellow: v,
  lightYellow: x,
  darkPurple: G,
  darkGrayOnWhite: O,
  dataVizColor1: R,
  dataVizColor2: T,
  dataVizColor3: W,
  dataVizColor3Background: Y,
  dataVizColor4: A,
  dataVizColor5: P,
  dataVizColor5Background: S,
  dataVizColor6: j,
  dataVizColor7: K,
  dataVizColor8: $,
  dataVizColor8Background: D,
  dataVizColor9: E,
  dataVizColor10: H,
  dataVizColor10Background: q,
  dataVizAlertOrange: F,
  dataVizSuccessGreen: J,
  dataVizWarningRed: M,
  "no-visible": "_no-visible_14r1r_34",
  html: Q,
  "footer-bottom-legallink-container": "_footer-bottom-legallink-container_14r1r_72",
  "footer-legallink": "_footer-legallink_14r1r_82",
  copyright: U,
  "legal-link-container": "_legal-link-container_14r1r_99",
  "legal-link-section": "_legal-link-section_14r1r_107",
  "button-container": "_button-container_14r1r_113",
  "legal-icon-container": "_legal-icon-container_14r1r_122",
  "legal-icon-image": "_legal-icon-image_14r1r_130",
  "legal-link": "_legal-link_14r1r_99",
  "legal-link-separators": "_legal-link-separators_14r1r_145"
}, L = ({ legalLink: d }) => {
  const { disclaimer: g, link: l, footerImage: t } = d || {}, m = f(), k = h(), n = () => {
    var e, i, c;
    (c = (e = window.utag) == null ? void 0 : e.gdpr) == null || c.showConsentPreferences((i = k.params) == null ? void 0 : i.locale);
  };
  return /* @__PURE__ */ r("div", { className: a["footer-bottom-legallink-container"], "data-testid": "legallink-container-test-id", "data-pod-name": "commerce", children: [
    /* @__PURE__ */ r("div", { className: a["footer-legallink"], "data-testid": "legallink-test-id", "data-pod-name": "commerce", children: [
      /* @__PURE__ */ o("span", { className: a.copyright, "data-testid": "legallink-disclaimer-test-id", "data-pod-name": "commerce", children: g }),
      /* @__PURE__ */ r("div", { className: a["legal-link-container"], children: [
        l && l.map((e) => /* @__PURE__ */ o("div", { className: a["button-container"], children: /* @__PURE__ */ r(
          s,
          {
            href: e == null ? void 0 : e.url,
            target: e.target,
            forceNative: e == null ? void 0 : e.url.includes(".xml"),
            className: a["legal-link-section"],
            children: [
              /* @__PURE__ */ o("span", { className: a["legal-link"], "data-testid": "link-test-id", "data-pod-name": "commerce", children: e.text }),
              /* @__PURE__ */ o("span", { className: a["legal-link-separators"], children: "|" })
            ]
          },
          e == null ? void 0 : e.text
        ) }, e.text)),
        /* @__PURE__ */ o(
          "div",
          {
            className: a["button-container"],
            role: "link",
            onClick: n,
            tabIndex: 0,
            onKeyDown: n,
            "aria-label": "footer link",
            children: /* @__PURE__ */ o("span", { className: a["legal-link"], children: m("web.footer.cookies") })
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ o("div", { className: a["legal-icon-container"], "data-testid": "legal-icon-container-id", "data-pod-name": "commerce", children: t && t.map((e) => /* @__PURE__ */ o("div", { className: a["legal-icon-image"], children: /* @__PURE__ */ o(
      s,
      {
        href: e.link.url,
        target: e.link.target,
        children: /* @__PURE__ */ o(
          u,
          {
            loaderType: _.CONTENTSTACK,
            src: e.url,
            alt: e.alt
          },
          `${e.url}`
        )
      },
      `${e.url}`
    ) }, e.url)) })
  ] });
};
export {
  L as default
};
//# sourceMappingURL=LegalLink.js.map
